export default __webpack_public_path__ + "static/media/hust.ba27df44.png";